module.exports = __webpack_public_path__ + "img/20190926154435558.2a31158d.jpg";